import {
  BR_AGE_RATING_DATA,
  BR_AGE_RATING_LABELS,
  STORAGE_SHOW_MODAL_GRAN_HERMANO,
  TAPPP_MODAL_VIEW_STORAGED,
  STORAGE_SHOW_WARNING_DGO_SKYMAIS,
  SHOW_TAPPP_MODAL_STORAGED,
  TAPPP_CONFIG_DATA,
  NEW_EPG_CONFIG_DATA,
  PLAYER_CONFIG_OVERRIDE_DATA,
} from './constants';

import {
  PARENTAL_CONTROL_COUNTRIES,
  GRAN_HERMANO_COUNTRIES,
  TAPPP_SDK_COUNTRIES,
  tapppBetsCountries,
  TAPPP_UNSUPPORTED_OS_VERSIONS,
  TAPPP_ALLOWED_USERS,
  IS_TAPPP_SDK_ACTIVE,
  isLoginFlowCreateAccountActive,
  loginFlowCreateAccountCountries,
  IS_LOW_END_DEVICE,
  tapppXSportsSdkActive,
  newEPGAllowedUsers,
  PLAYER_RESOLUTION_OVERRIDES,
  playerConfigOverrideRules,
} from './env';

const findAgeRatingLabel = (rating) => BR_AGE_RATING_LABELS[rating];
const userAllContentAllowed = (
  lastItem,
  currentAgeRating,
) => lastItem === currentAgeRating;

export function isGranHermanoActiveForCountry(country) {
  if (country) {
    return GRAN_HERMANO_COUNTRIES.has(country.toLowerCase());
  }

  return false;
}

export function featureFlagParentalControl(country) {
  return country ? PARENTAL_CONTROL_COUNTRIES.has(country) : false;
}

export function getInitials(userName) {
  return userName
    ?.match(/(?:^|\s)\S/g)
    ?.slice(0, 2)
    ?.join('')
    ?.replace(/ /g, '')
    ?.split('');
}
// Removes empty spaces on the sides of the string.
export function formatName(userName) { return userName.replace(/^\s+|\s+$/g, ''); }

export function getAllowedContentOption(ageRating) {
  const findAgeRatingValue = BR_AGE_RATING_DATA[ageRating];
  const profileRatingLabel = findAgeRatingLabel(ageRating);
  const userChangedRatedLabel = findAgeRatingLabel(findAgeRatingValue);
  const lastItem = Object.keys(BR_AGE_RATING_DATA).pop();
  const hasAllContent = userAllContentAllowed(lastItem, ageRating.toString());
  const lastKey = Object.keys(BR_AGE_RATING_LABELS).slice(-1).join(',');

  if (profileRatingLabel) {
    // Initial Age Rating user
    return (lastKey === ageRating) ? false : profileRatingLabel;
  }
  if (findAgeRatingValue) {
    // Change Age Rating user
    return hasAllContent ? BR_AGE_RATING_LABELS[lastItem] : userChangedRatedLabel;
  }
  // All content Allowed
  return undefined;
}

export function getKeyByValue(object, value) {
  return (Object.keys(object).find((key) => object[key] === value));
}

export function getAgeRating(rating) {
  return BR_AGE_RATING_DATA[rating];
}

export function checkUnratedContent(obj) {
  return obj ? Object.keys(obj).length > 0 : false;
}

// Check if the user has changed the name or Age rating from the Allowed content / Edit page.
export function isProfileOptionsChanged(
  ageRating,
  ratedContentAllowed,
  selectedProfile = {},
) {
  const isAgeRatingDifferent = ageRating && (ageRating !== selectedProfile?.ageRating);
  const isNotRatedContentAllowed = ratedContentAllowed
    !== selectedProfile?.isNotRatedContentAllowed;
  return isAgeRatingDifferent || isNotRatedContentAllowed;
}

export function getProfileSelected() {
  return JSON.parse(localStorage.getItem('profile'));
}

export function getProfilesAlreadyViewedGranHermanoModal() {
  return JSON.parse(
    localStorage.getItem(STORAGE_SHOW_MODAL_GRAN_HERMANO),
  ) || [];
}

export function getStoragedShowWarningSkyMais() {
  return JSON.parse(localStorage.getItem(STORAGE_SHOW_WARNING_DGO_SKYMAIS));
}

export function isTapppSDKActiveForCountry(country) {
  return country ? TAPPP_SDK_COUNTRIES.has(country.toLowerCase()) : false;
}

export function isTapppBetsActiveForCountry(country) {
  return country ? tapppBetsCountries.has(country.toLowerCase()) : false;
}

export function getProfilesAlreadyViewedTapppModal() {
  return JSON.parse(
    localStorage.getItem(TAPPP_MODAL_VIEW_STORAGED),
  ) || [];
}

export function getStoragedShowTapppModal() {
  return JSON.parse(localStorage.getItem(SHOW_TAPPP_MODAL_STORAGED));
}

export function isTapppPanelAllowedForUser(userId) {
  const securityAllUsers = 'allUsersAllowed';
  return TAPPP_ALLOWED_USERS.has(userId)
    || TAPPP_ALLOWED_USERS.has(TAPPP_CONFIG_DATA.allUsersAllowed || securityAllUsers);
}

export function isNewEPGAllowedForUser(userId) {
  const securityAllUsers = 'allUsersAllowed';
  return newEPGAllowedUsers.has(userId)
    || newEPGAllowedUsers.has(NEW_EPG_CONFIG_DATA.allUsersAllowed || securityAllUsers);
}

export function isTapppSDKActiveForOsVersion(osName, sdkVersion) {
  const currentPlatformMatch = TAPPP_UNSUPPORTED_OS_VERSIONS[osName];

  if (currentPlatformMatch) {
    const regexp = new RegExp(currentPlatformMatch);

    return !regexp.test(sdkVersion);
  }
  return true;
}

export function isLowEndProfile(osName, sdkVersion) {
  const currentPlatformMatch = IS_LOW_END_DEVICE[osName];

  if (currentPlatformMatch) {
    const regexp = new RegExp(currentPlatformMatch);

    return regexp.test(sdkVersion);
  }
  return false;
}

export function isTapppPanelEnabledForUser(iso2Code, userId) {
  if ((IS_TAPPP_SDK_ACTIVE || tapppXSportsSdkActive) && isTapppSDKActiveForCountry(iso2Code)) {
    return isTapppPanelAllowedForUser(userId);
  }
  return false;
}

export function isNewEPGEnabledForUser(userId) {
  return isNewEPGAllowedForUser(userId);
}

export function isCreateAccountActiveForCountry(country) {
  if (country) {
    return isLoginFlowCreateAccountActive
      && loginFlowCreateAccountCountries.has(country.toLowerCase());
  }

  return false;
}

export function getResolutionOverride(osName, sdkVersion) {
  if (!Array.isArray(PLAYER_RESOLUTION_OVERRIDES)) return undefined;

  const match = PLAYER_RESOLUTION_OVERRIDES.find((entry) => {
    const pattern = entry.so?.[osName];

    if (!pattern) return false;

    return new RegExp(pattern).test(sdkVersion);
  });

  return match?.resolution;
}

export function getPlayerConfigOverrideByOS(osName, sdkVersion) {
  if (!Array.isArray(playerConfigOverrideRules)
    || playerConfigOverrideRules.length === 0) return undefined;

  const { allSystemsAllowed } = PLAYER_CONFIG_OVERRIDE_DATA;

  const match = playerConfigOverrideRules.find((entry) => {
    const pattern = entry.so?.[osName];

    if (!pattern) return false;

    return new RegExp(pattern).test(sdkVersion);
  });

  if (match) return match.configOverride;

  const fallback = playerConfigOverrideRules.find((entry) => entry.so?.[allSystemsAllowed]);

  return fallback?.configOverride;
}
